import { renderToNodeList } from 'react-fela';
export function StyleTags(_ref) {
  let {
    renderer
  } = _ref;
  return renderToNodeList(renderer);
}